import { GtdFlagAc } from './GtdFlag-ac.icon';
import { GtdFlagAd } from './GtdFlag-ad.icon';
import { GtdFlagAe } from './GtdFlag-ae.icon';
import { GtdFlagAf } from './GtdFlag-af.icon';
import { GtdFlagAg } from './GtdFlag-ag.icon';
import { GtdFlagAi } from './GtdFlag-ai.icon';
import { GtdFlagAl } from './GtdFlag-al.icon';
import { GtdFlagAm } from './GtdFlag-am.icon';
import { GtdFlagAo } from './GtdFlag-ao.icon';
import { GtdFlagAq } from './GtdFlag-aq.icon';
import { GtdFlagAr } from './GtdFlag-ar.icon';
import { GtdFlagAs } from './GtdFlag-as.icon';
import { GtdFlagAt } from './GtdFlag-at.icon';
import { GtdFlagAu } from './GtdFlag-au.icon';
import { GtdFlagAw } from './GtdFlag-aw.icon';
import { GtdFlagAx } from './GtdFlag-ax.icon';
import { GtdFlagAz } from './GtdFlag-az.icon';
import { GtdFlagBa } from './GtdFlag-ba.icon';
import { GtdFlagBb } from './GtdFlag-bb.icon';
import { GtdFlagBd } from './GtdFlag-bd.icon';
import { GtdFlagBe } from './GtdFlag-be.icon';
import { GtdFlagBf } from './GtdFlag-bf.icon';
import { GtdFlagBg } from './GtdFlag-bg.icon';
import { GtdFlagBh } from './GtdFlag-bh.icon';
import { GtdFlagBi } from './GtdFlag-bi.icon';
import { GtdFlagBj } from './GtdFlag-bj.icon';
import { GtdFlagBl } from './GtdFlag-bl.icon';
import { GtdFlagBm } from './GtdFlag-bm.icon';
import { GtdFlagBn } from './GtdFlag-bn.icon';
import { GtdFlagBo } from './GtdFlag-bo.icon';
import { GtdFlagBq } from './GtdFlag-bq.icon';
import { GtdFlagBr } from './GtdFlag-br.icon';
import { GtdFlagBs } from './GtdFlag-bs.icon';
import { GtdFlagBt } from './GtdFlag-bt.icon';
import { GtdFlagBv } from './GtdFlag-bv.icon';
import { GtdFlagBw } from './GtdFlag-bw.icon';
import { GtdFlagBy } from './GtdFlag-by.icon';
import { GtdFlagBz } from './GtdFlag-bz.icon';
import { GtdFlagCa } from './GtdFlag-ca.icon';
import { GtdFlagCc } from './GtdFlag-cc.icon';
import { GtdFlagCd } from './GtdFlag-cd.icon';
import { GtdFlagCefta } from './GtdFlag-cefta.icon';
import { GtdFlagCf } from './GtdFlag-cf.icon';
import { GtdFlagCg } from './GtdFlag-cg.icon';
import { GtdFlagCh } from './GtdFlag-ch.icon';
import { GtdFlagCi } from './GtdFlag-ci.icon';
import { GtdFlagCk } from './GtdFlag-ck.icon';
import { GtdFlagCl } from './GtdFlag-cl.icon';
import { GtdFlagCm } from './GtdFlag-cm.icon';
import { GtdFlagCn } from './GtdFlag-cn.icon';
import { GtdFlagCo } from './GtdFlag-co.icon';
import { GtdFlagCp } from './GtdFlag-cp.icon';
import { GtdFlagCr } from './GtdFlag-cr.icon';
import { GtdFlagCu } from './GtdFlag-cu.icon';
import { GtdFlagCv } from './GtdFlag-cv.icon';
import { GtdFlagCw } from './GtdFlag-cw.icon';
import { GtdFlagCx } from './GtdFlag-cx.icon';
import { GtdFlagCy } from './GtdFlag-cy.icon';
import { GtdFlagCz } from './GtdFlag-cz.icon';
import { GtdFlagDe } from './GtdFlag-de.icon';
import { GtdFlagDg } from './GtdFlag-dg.icon';
import { GtdFlagDj } from './GtdFlag-dj.icon';
import { GtdFlagDk } from './GtdFlag-dk.icon';
import { GtdFlagDm } from './GtdFlag-dm.icon';
import { GtdFlagDo } from './GtdFlag-do.icon';
import { GtdFlagDz } from './GtdFlag-dz.icon';
import { GtdFlagEa } from './GtdFlag-ea.icon';
import { GtdFlagEc } from './GtdFlag-ec.icon';
import { GtdFlagEe } from './GtdFlag-ee.icon';
import { GtdFlagEg } from './GtdFlag-eg.icon';
import { GtdFlagEh } from './GtdFlag-eh.icon';
import { GtdFlagEr } from './GtdFlag-er.icon';
import { GtdFlagEsCt } from './GtdFlag-es-ct.icon';
import { GtdFlagEsGa } from './GtdFlag-es-ga.icon';
import { GtdFlagEsPv } from './GtdFlag-es-pv.icon';
import { GtdFlagEs } from './GtdFlag-es.icon';
import { GtdFlagEt } from './GtdFlag-et.icon';
import { GtdFlagEu } from './GtdFlag-eu.icon';
import { GtdFlagFi } from './GtdFlag-fi.icon';
import { GtdFlagFj } from './GtdFlag-fj.icon';
import { GtdFlagFk } from './GtdFlag-fk.icon';
import { GtdFlagFm } from './GtdFlag-fm.icon';
import { GtdFlagFo } from './GtdFlag-fo.icon';
import { GtdFlagFr } from './GtdFlag-fr.icon';
import { GtdFlagGa } from './GtdFlag-ga.icon';
import { GtdFlagGbEng } from './GtdFlag-gb-eng.icon';
import { GtdFlagGbNir } from './GtdFlag-gb-nir.icon';
import { GtdFlagGbSct } from './GtdFlag-gb-sct.icon';
import { GtdFlagGbWls } from './GtdFlag-gb-wls.icon';
import { GtdFlagGb } from './GtdFlag-gb.icon';
import { GtdFlagGd } from './GtdFlag-gd.icon';
import { GtdFlagGe } from './GtdFlag-ge.icon';
import { GtdFlagGf } from './GtdFlag-gf.icon';
import { GtdFlagGg } from './GtdFlag-gg.icon';
import { GtdFlagGh } from './GtdFlag-gh.icon';
import { GtdFlagGi } from './GtdFlag-gi.icon';
import { GtdFlagGl } from './GtdFlag-gl.icon';
import { GtdFlagGm } from './GtdFlag-gm.icon';
import { GtdFlagGn } from './GtdFlag-gn.icon';
import { GtdFlagGp } from './GtdFlag-gp.icon';
import { GtdFlagGq } from './GtdFlag-gq.icon';
import { GtdFlagGr } from './GtdFlag-gr.icon';
import { GtdFlagGs } from './GtdFlag-gs.icon';
import { GtdFlagGt } from './GtdFlag-gt.icon';
import { GtdFlagGu } from './GtdFlag-gu.icon';
import { GtdFlagGw } from './GtdFlag-gw.icon';
import { GtdFlagGy } from './GtdFlag-gy.icon';
import { GtdFlagHk } from './GtdFlag-hk.icon';
import { GtdFlagHm } from './GtdFlag-hm.icon';
import { GtdFlagHn } from './GtdFlag-hn.icon';
import { GtdFlagHr } from './GtdFlag-hr.icon';
import { GtdFlagHt } from './GtdFlag-ht.icon';
import { GtdFlagHu } from './GtdFlag-hu.icon';
import { GtdFlagIc } from './GtdFlag-ic.icon';
import { GtdFlagId } from './GtdFlag-id.icon';
import { GtdFlagIe } from './GtdFlag-ie.icon';
import { GtdFlagIl } from './GtdFlag-il.icon';
import { GtdFlagIm } from './GtdFlag-im.icon';
import { GtdFlagIn } from './GtdFlag-in.icon';
import { GtdFlagIo } from './GtdFlag-io.icon';
import { GtdFlagIq } from './GtdFlag-iq.icon';
import { GtdFlagIr } from './GtdFlag-ir.icon';
import { GtdFlagIs } from './GtdFlag-is.icon';
import { GtdFlagIt } from './GtdFlag-it.icon';
import { GtdFlagJe } from './GtdFlag-je.icon';
import { GtdFlagJm } from './GtdFlag-jm.icon';
import { GtdFlagJo } from './GtdFlag-jo.icon';
import { GtdFlagJp } from './GtdFlag-jp.icon';
import { GtdFlagKe } from './GtdFlag-ke.icon';
import { GtdFlagKg } from './GtdFlag-kg.icon';
import { GtdFlagKh } from './GtdFlag-kh.icon';
import { GtdFlagKi } from './GtdFlag-ki.icon';
import { GtdFlagKm } from './GtdFlag-km.icon';
import { GtdFlagKn } from './GtdFlag-kn.icon';
import { GtdFlagKp } from './GtdFlag-kp.icon';
import { GtdFlagKr } from './GtdFlag-kr.icon';
import { GtdFlagKw } from './GtdFlag-kw.icon';
import { GtdFlagKy } from './GtdFlag-ky.icon';
import { GtdFlagKz } from './GtdFlag-kz.icon';
import { GtdFlagLa } from './GtdFlag-la.icon';
import { GtdFlagLb } from './GtdFlag-lb.icon';
import { GtdFlagLc } from './GtdFlag-lc.icon';
import { GtdFlagLi } from './GtdFlag-li.icon';
import { GtdFlagLk } from './GtdFlag-lk.icon';
import { GtdFlagLr } from './GtdFlag-lr.icon';
import { GtdFlagLs } from './GtdFlag-ls.icon';
import { GtdFlagLt } from './GtdFlag-lt.icon';
import { GtdFlagLu } from './GtdFlag-lu.icon';
import { GtdFlagLv } from './GtdFlag-lv.icon';
import { GtdFlagLy } from './GtdFlag-ly.icon';
import { GtdFlagMa } from './GtdFlag-ma.icon';
import { GtdFlagMc } from './GtdFlag-mc.icon';
import { GtdFlagMd } from './GtdFlag-md.icon';
import { GtdFlagMe } from './GtdFlag-me.icon';
import { GtdFlagMf } from './GtdFlag-mf.icon';
import { GtdFlagMg } from './GtdFlag-mg.icon';
import { GtdFlagMh } from './GtdFlag-mh.icon';
import { GtdFlagMk } from './GtdFlag-mk.icon';
import { GtdFlagMl } from './GtdFlag-ml.icon';
import { GtdFlagMm } from './GtdFlag-mm.icon';
import { GtdFlagMn } from './GtdFlag-mn.icon';
import { GtdFlagMo } from './GtdFlag-mo.icon';
import { GtdFlagMp } from './GtdFlag-mp.icon';
import { GtdFlagMq } from './GtdFlag-mq.icon';
import { GtdFlagMr } from './GtdFlag-mr.icon';
import { GtdFlagMs } from './GtdFlag-ms.icon';
import { GtdFlagMt } from './GtdFlag-mt.icon';
import { GtdFlagMu } from './GtdFlag-mu.icon';
import { GtdFlagMv } from './GtdFlag-mv.icon';
import { GtdFlagMw } from './GtdFlag-mw.icon';
import { GtdFlagMx } from './GtdFlag-mx.icon';
import { GtdFlagMy } from './GtdFlag-my.icon';
import { GtdFlagMz } from './GtdFlag-mz.icon';
import { GtdFlagNa } from './GtdFlag-na.icon';
import { GtdFlagNc } from './GtdFlag-nc.icon';
import { GtdFlagNe } from './GtdFlag-ne.icon';
import { GtdFlagNf } from './GtdFlag-nf.icon';
import { GtdFlagNg } from './GtdFlag-ng.icon';
import { GtdFlagNi } from './GtdFlag-ni.icon';
import { GtdFlagNl } from './GtdFlag-nl.icon';
import { GtdFlagNo } from './GtdFlag-no.icon';
import { GtdFlagNp } from './GtdFlag-np.icon';
import { GtdFlagNr } from './GtdFlag-nr.icon';
import { GtdFlagNu } from './GtdFlag-nu.icon';
import { GtdFlagNz } from './GtdFlag-nz.icon';
import { GtdFlagOm } from './GtdFlag-om.icon';
import { GtdFlagPa } from './GtdFlag-pa.icon';
import { GtdFlagPe } from './GtdFlag-pe.icon';
import { GtdFlagPf } from './GtdFlag-pf.icon';
import { GtdFlagPg } from './GtdFlag-pg.icon';
import { GtdFlagPh } from './GtdFlag-ph.icon';
import { GtdFlagPk } from './GtdFlag-pk.icon';
import { GtdFlagPl } from './GtdFlag-pl.icon';
import { GtdFlagPm } from './GtdFlag-pm.icon';
import { GtdFlagPn } from './GtdFlag-pn.icon';
import { GtdFlagPr } from './GtdFlag-pr.icon';
import { GtdFlagPs } from './GtdFlag-ps.icon';
import { GtdFlagPt } from './GtdFlag-pt.icon';
import { GtdFlagPw } from './GtdFlag-pw.icon';
import { GtdFlagPy } from './GtdFlag-py.icon';
import { GtdFlagQa } from './GtdFlag-qa.icon';
import { GtdFlagRe } from './GtdFlag-re.icon';
import { GtdFlagRo } from './GtdFlag-ro.icon';
import { GtdFlagRs } from './GtdFlag-rs.icon';
import { GtdFlagRu } from './GtdFlag-ru.icon';
import { GtdFlagRw } from './GtdFlag-rw.icon';
import { GtdFlagSa } from './GtdFlag-sa.icon';
import { GtdFlagSb } from './GtdFlag-sb.icon';
import { GtdFlagSc } from './GtdFlag-sc.icon';
import { GtdFlagSd } from './GtdFlag-sd.icon';
import { GtdFlagSe } from './GtdFlag-se.icon';
import { GtdFlagSg } from './GtdFlag-sg.icon';
import { GtdFlagSh } from './GtdFlag-sh.icon';
import { GtdFlagSi } from './GtdFlag-si.icon';
import { GtdFlagSj } from './GtdFlag-sj.icon';
import { GtdFlagSk } from './GtdFlag-sk.icon';
import { GtdFlagSl } from './GtdFlag-sl.icon';
import { GtdFlagSm } from './GtdFlag-sm.icon';
import { GtdFlagSn } from './GtdFlag-sn.icon';
import { GtdFlagSo } from './GtdFlag-so.icon';
import { GtdFlagSr } from './GtdFlag-sr.icon';
import { GtdFlagSs } from './GtdFlag-ss.icon';
import { GtdFlagSt } from './GtdFlag-st.icon';
import { GtdFlagSv } from './GtdFlag-sv.icon';
import { GtdFlagSx } from './GtdFlag-sx.icon';
import { GtdFlagSy } from './GtdFlag-sy.icon';
import { GtdFlagSz } from './GtdFlag-sz.icon';
import { GtdFlagTa } from './GtdFlag-ta.icon';
import { GtdFlagTc } from './GtdFlag-tc.icon';
import { GtdFlagTd } from './GtdFlag-td.icon';
import { GtdFlagTf } from './GtdFlag-tf.icon';
import { GtdFlagTg } from './GtdFlag-tg.icon';
import { GtdFlagTh } from './GtdFlag-th.icon';
import { GtdFlagTj } from './GtdFlag-tj.icon';
import { GtdFlagTk } from './GtdFlag-tk.icon';
import { GtdFlagTl } from './GtdFlag-tl.icon';
import { GtdFlagTm } from './GtdFlag-tm.icon';
import { GtdFlagTn } from './GtdFlag-tn.icon';
import { GtdFlagTo } from './GtdFlag-to.icon';
import { GtdFlagTr } from './GtdFlag-tr.icon';
import { GtdFlagTt } from './GtdFlag-tt.icon';
import { GtdFlagTv } from './GtdFlag-tv.icon';
import { GtdFlagTw } from './GtdFlag-tw.icon';
import { GtdFlagTz } from './GtdFlag-tz.icon';
import { GtdFlagUa } from './GtdFlag-ua.icon';
import { GtdFlagUg } from './GtdFlag-ug.icon';
import { GtdFlagUm } from './GtdFlag-um.icon';
import { GtdFlagUn } from './GtdFlag-un.icon';
import { GtdFlagUs } from './GtdFlag-us.icon';
import { GtdFlagUy } from './GtdFlag-uy.icon';
import { GtdFlagUz } from './GtdFlag-uz.icon';
import { GtdFlagVa } from './GtdFlag-va.icon';
import { GtdFlagVc } from './GtdFlag-vc.icon';
import { GtdFlagVe } from './GtdFlag-ve.icon';
import { GtdFlagVg } from './GtdFlag-vg.icon';
import { GtdFlagVi } from './GtdFlag-vi.icon';
import { GtdFlagVn } from './GtdFlag-vn.icon';
import { GtdFlagVu } from './GtdFlag-vu.icon';
import { GtdFlagWf } from './GtdFlag-wf.icon';
import { GtdFlagWs } from './GtdFlag-ws.icon';
import { GtdFlagXk } from './GtdFlag-xk.icon';
import { GtdFlagXx } from './GtdFlag-xx.icon';
import { GtdFlagYe } from './GtdFlag-ye.icon';
import { GtdFlagYt } from './GtdFlag-yt.icon';
import { GtdFlagZa } from './GtdFlag-za.icon';
import { GtdFlagZm } from './GtdFlag-zm.icon';
import { GtdFlagZw } from './GtdFlag-zw.icon';
export var completeIconSet = [
    GtdFlagAc,
    GtdFlagAd,
    GtdFlagAe,
    GtdFlagAf,
    GtdFlagAg,
    GtdFlagAi,
    GtdFlagAl,
    GtdFlagAm,
    GtdFlagAo,
    GtdFlagAq,
    GtdFlagAr,
    GtdFlagAs,
    GtdFlagAt,
    GtdFlagAu,
    GtdFlagAw,
    GtdFlagAx,
    GtdFlagAz,
    GtdFlagBa,
    GtdFlagBb,
    GtdFlagBd,
    GtdFlagBe,
    GtdFlagBf,
    GtdFlagBg,
    GtdFlagBh,
    GtdFlagBi,
    GtdFlagBj,
    GtdFlagBl,
    GtdFlagBm,
    GtdFlagBn,
    GtdFlagBo,
    GtdFlagBq,
    GtdFlagBr,
    GtdFlagBs,
    GtdFlagBt,
    GtdFlagBv,
    GtdFlagBw,
    GtdFlagBy,
    GtdFlagBz,
    GtdFlagCa,
    GtdFlagCc,
    GtdFlagCd,
    GtdFlagCefta,
    GtdFlagCf,
    GtdFlagCg,
    GtdFlagCh,
    GtdFlagCi,
    GtdFlagCk,
    GtdFlagCl,
    GtdFlagCm,
    GtdFlagCn,
    GtdFlagCo,
    GtdFlagCp,
    GtdFlagCr,
    GtdFlagCu,
    GtdFlagCv,
    GtdFlagCw,
    GtdFlagCx,
    GtdFlagCy,
    GtdFlagCz,
    GtdFlagDe,
    GtdFlagDg,
    GtdFlagDj,
    GtdFlagDk,
    GtdFlagDm,
    GtdFlagDo,
    GtdFlagDz,
    GtdFlagEa,
    GtdFlagEc,
    GtdFlagEe,
    GtdFlagEg,
    GtdFlagEh,
    GtdFlagEr,
    GtdFlagEsCt,
    GtdFlagEsGa,
    GtdFlagEsPv,
    GtdFlagEs,
    GtdFlagEt,
    GtdFlagEu,
    GtdFlagFi,
    GtdFlagFj,
    GtdFlagFk,
    GtdFlagFm,
    GtdFlagFo,
    GtdFlagFr,
    GtdFlagGa,
    GtdFlagGbEng,
    GtdFlagGbNir,
    GtdFlagGbSct,
    GtdFlagGbWls,
    GtdFlagGb,
    GtdFlagGd,
    GtdFlagGe,
    GtdFlagGf,
    GtdFlagGg,
    GtdFlagGh,
    GtdFlagGi,
    GtdFlagGl,
    GtdFlagGm,
    GtdFlagGn,
    GtdFlagGp,
    GtdFlagGq,
    GtdFlagGr,
    GtdFlagGs,
    GtdFlagGt,
    GtdFlagGu,
    GtdFlagGw,
    GtdFlagGy,
    GtdFlagHk,
    GtdFlagHm,
    GtdFlagHn,
    GtdFlagHr,
    GtdFlagHt,
    GtdFlagHu,
    GtdFlagIc,
    GtdFlagId,
    GtdFlagIe,
    GtdFlagIl,
    GtdFlagIm,
    GtdFlagIn,
    GtdFlagIo,
    GtdFlagIq,
    GtdFlagIr,
    GtdFlagIs,
    GtdFlagIt,
    GtdFlagJe,
    GtdFlagJm,
    GtdFlagJo,
    GtdFlagJp,
    GtdFlagKe,
    GtdFlagKg,
    GtdFlagKh,
    GtdFlagKi,
    GtdFlagKm,
    GtdFlagKn,
    GtdFlagKp,
    GtdFlagKr,
    GtdFlagKw,
    GtdFlagKy,
    GtdFlagKz,
    GtdFlagLa,
    GtdFlagLb,
    GtdFlagLc,
    GtdFlagLi,
    GtdFlagLk,
    GtdFlagLr,
    GtdFlagLs,
    GtdFlagLt,
    GtdFlagLu,
    GtdFlagLv,
    GtdFlagLy,
    GtdFlagMa,
    GtdFlagMc,
    GtdFlagMd,
    GtdFlagMe,
    GtdFlagMf,
    GtdFlagMg,
    GtdFlagMh,
    GtdFlagMk,
    GtdFlagMl,
    GtdFlagMm,
    GtdFlagMn,
    GtdFlagMo,
    GtdFlagMp,
    GtdFlagMq,
    GtdFlagMr,
    GtdFlagMs,
    GtdFlagMt,
    GtdFlagMu,
    GtdFlagMv,
    GtdFlagMw,
    GtdFlagMx,
    GtdFlagMy,
    GtdFlagMz,
    GtdFlagNa,
    GtdFlagNc,
    GtdFlagNe,
    GtdFlagNf,
    GtdFlagNg,
    GtdFlagNi,
    GtdFlagNl,
    GtdFlagNo,
    GtdFlagNp,
    GtdFlagNr,
    GtdFlagNu,
    GtdFlagNz,
    GtdFlagOm,
    GtdFlagPa,
    GtdFlagPe,
    GtdFlagPf,
    GtdFlagPg,
    GtdFlagPh,
    GtdFlagPk,
    GtdFlagPl,
    GtdFlagPm,
    GtdFlagPn,
    GtdFlagPr,
    GtdFlagPs,
    GtdFlagPt,
    GtdFlagPw,
    GtdFlagPy,
    GtdFlagQa,
    GtdFlagRe,
    GtdFlagRo,
    GtdFlagRs,
    GtdFlagRu,
    GtdFlagRw,
    GtdFlagSa,
    GtdFlagSb,
    GtdFlagSc,
    GtdFlagSd,
    GtdFlagSe,
    GtdFlagSg,
    GtdFlagSh,
    GtdFlagSi,
    GtdFlagSj,
    GtdFlagSk,
    GtdFlagSl,
    GtdFlagSm,
    GtdFlagSn,
    GtdFlagSo,
    GtdFlagSr,
    GtdFlagSs,
    GtdFlagSt,
    GtdFlagSv,
    GtdFlagSx,
    GtdFlagSy,
    GtdFlagSz,
    GtdFlagTa,
    GtdFlagTc,
    GtdFlagTd,
    GtdFlagTf,
    GtdFlagTg,
    GtdFlagTh,
    GtdFlagTj,
    GtdFlagTk,
    GtdFlagTl,
    GtdFlagTm,
    GtdFlagTn,
    GtdFlagTo,
    GtdFlagTr,
    GtdFlagTt,
    GtdFlagTv,
    GtdFlagTw,
    GtdFlagTz,
    GtdFlagUa,
    GtdFlagUg,
    GtdFlagUm,
    GtdFlagUn,
    GtdFlagUs,
    GtdFlagUy,
    GtdFlagUz,
    GtdFlagVa,
    GtdFlagVc,
    GtdFlagVe,
    GtdFlagVg,
    GtdFlagVi,
    GtdFlagVn,
    GtdFlagVu,
    GtdFlagWf,
    GtdFlagWs,
    GtdFlagXk,
    GtdFlagXx,
    GtdFlagYe,
    GtdFlagYt,
    GtdFlagZa,
    GtdFlagZm,
    GtdFlagZw
];
